import { uiRuntimeConfig } from 'lib_ui-services';

/**
 * @returns {'sst'|'redbeam'}
 */
export default function useBrand() {
    return uiRuntimeConfig.getBrand();
}
